import { render, staticRenderFns } from "./terminalsTemplate.vue?vue&type=template&id=31345d8d&"
import script from "./terminalsTemplate.vue?vue&type=script&lang=js&"
export * from "./terminalsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports